/**
 * Servicio encargado de renderizar mathjax.
 * Debe inyectarse en los componentes donde se quiera usar la libreria.
 */
import { Injectable } from '@angular/core';

declare global {
  interface Window {
    MathJax: any;
  }
}

@Injectable({ providedIn: 'root' })
export class MathJaxService {
  private initialized = false;

  initMathJax(): void {
    if (this.initialized || window.MathJax) return;

    this.initialized = true;

    window.MathJax = {
      loader: { load: ['input/tex', 'output/chtml'] },
      tex: {
        inlineMath: [['$', '$'], ['\\(', '\\)']],
        displayMath: [['$$', '$$'], ['\\[', '\\]']],
      },
      chtml: { scale: 1 },
      startup: { typeset: false },
    };

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml.js';
    script.async = true;
    document.head.appendChild(script);
  }

  renderMath(): void {
    if (window.MathJax) {
      window.MathJax.typesetPromise?.();
    }
  }
}

